import { useState } from "react";
import { CalendarClock, RefreshCw, Loader2, Bell } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../../lib/api";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" }) : "—");
const STATE = { up_to_date: ["UP TO DATE", "text-emerald-700 border-emerald-200 bg-emerald-50"], due_soon: ["DUE SOON", "text-amber-700 border-amber-200 bg-amber-50"], overdue: ["OVERDUE", "text-red-700 border-red-200 bg-red-50"] };

export const Accuracy = ({ p, reload }) => {
  const [focus, setFocus] = useState("");
  const ei = p.edition_info || {};
  const [label, cls] = STATE[ei.state] || STATE.up_to_date;
  const go = async () => {
    try { await http.post(`/extras/products/${p.id}/refresh`, { focus }); toast.success("Re-checking the guide — a few minutes"); setFocus(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const test = async () => { try { await http.post(`/extras/products/${p.id}/test-reminder`); toast.success("Test reminder sent"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="ex-accuracy" className="ex-card grid md:grid-cols-[1.15fr_1fr] overflow-hidden">
      <div className="p-6 border-r border-[#E6DDCF]">
        <div className="flex items-center gap-2 mb-5">
          <CalendarClock size={14} className="text-[#8B6B4A]" /><span className="ex-eyebrow text-[10px]">Accuracy · 6-month update cycle</span>
          <span data-testid="ex-edition-state" className={`ml-auto ex-mono text-[9px] tracking-[0.18em] px-2 py-1 rounded border ${cls}`}>{label}</span>
        </div>
        <div className="grid grid-cols-3 gap-4 text-sm mb-6">
          <div><div className="text-stone-500 text-xs mb-1">Edition</div><div data-testid="ex-edition-number" className="ex-display text-xl">{ei.edition}</div></div>
          <div><div className="text-stone-500 text-xs mb-1">Last updated</div>{fmt(ei.last_updated)}</div>
          <div><div className="text-stone-500 text-xs mb-1">Next update due</div>{fmt(ei.next_due)}</div>
        </div>
        <input data-testid="ex-refresh-focus" value={focus} onChange={(e) => setFocus(e.target.value)} placeholder="Anything to focus on? e.g. new e-visa rules (optional)" className="w-full border border-stone-300 bg-white px-3 py-2 text-sm outline-none focus:border-[#8B6B4A] mb-3" />
        <button data-testid="ex-refresh" disabled={!!p.busy || !p.content} onClick={go} className="inline-flex items-center gap-2 bg-[#30271D] text-white px-4 py-2.5 text-sm hover:bg-black disabled:opacity-40">
          {p.busy === "refresh" ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />} {p.busy === "refresh" ? "Updating…" : "Update guide now"}
        </button>
        <p className="text-xs text-stone-500 mt-3">The AI re-checks visa rules, prices, hours and transport times, rewrites what's outdated and logs what changed. Your listing, price and publish status stay the same, and the shop PDF refreshes itself.</p>
        <div className="border-t border-[#E6DDCF] mt-5 pt-4 text-xs text-stone-600 flex gap-2"><Bell size={13} className="text-[#8B6B4A] shrink-0" />Email reminders: 2 weeks before and on the due date → admin@pbtravelangel.com</div>
        <button data-testid="ex-test-reminder" onClick={test} className="text-xs underline text-stone-600 mt-2 hover:text-stone-900">Send test reminder</button>
      </div>
      <div className="p-6">
        <div className="ex-eyebrow text-[10px] mb-4">Edition history</div>
        <div className="space-y-4">
          {[...(ei.history || [])].reverse().map((h) => (
            <div key={h.edition} data-testid={`ex-edition-${h.edition}`} className="border-l-2 border-[#8B6B4A] pl-4">
              <div className="flex items-baseline gap-3"><span className="ex-display text-lg">Edition {h.edition}</span><span className="text-xs text-stone-500">{fmt(h.date)}</span></div>
              <div className="text-sm text-stone-600 mt-0.5">{h.note}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
